import DesignThumbnail from './DesignThumbnail'

export default DesignThumbnail
